module.exports = __webpack_public_path__ + "static/media/users-icon.bab7f871.svg";